<template>
  <div class="page-content">
    <div class="container-fluid">
      <DataTable
        :refs="refs"
        :colspan="5"
        :hasSearchFilter="true"
        :hasHashId="true"
        :hasMultiSelect="false"
        :hasBulkAction="true"
        :hasExport="true"
        :addNew="addNew"
        :hasShowEntries="true"
        :hasStatusFilter="true"
        :lblSearch="$t('app.search')"
        :fields="{
          id: 'id',
          title: 'title',
        }"
        :hasImage="true"
        :image="$t('view.icon')"
        :image_style="'width: 40px;height: 40px;border-radius: 50%'"
        :hasTitle="true"
        :title="$t('view.country_title')"
        :hasCountryCode="true"
        :countryCode="$t('view.country_code')"
        :hasStatus="true"
        :hasActions="true"
        :hasDeleteButton="true"
        :actionable="true"
        :sorDataTable="true"
        v-on:hasAddNewPermission="handlePermissoinChange"
      >
      </DataTable>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import DataTable from "@/components/DataTable.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "List",
  components: {
    DataTable,
  },

  data() {
    return {
      //
      addNew: false,
      refs: "countries",
      isAdmin: localStorage.getItem("role_key") == "root" ? true : false,
    };
  },
  watch: {
    //
  },
  mounted() {
    //
  },
  created() {
    setCurrentPageTitle(this.$t("nav.countries"), "bx bx-map");
  },
  methods: {
    handlePermissoinChange(event) {
      this.addNew = event;
    },
  },
});
</script>
